// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"84e059ca","350":"f3c08fd0","360":"f2ae547d","445":"9d11256a","453":"e67b519e","455":"766972e6","536":"f04d3ab8","787":"1cdb2de3","827":"cbf165f3","944":"31df91be","977":"2626d0aa","994":"4f84371a"}[chunkId] + ".chunk.js";
};